import './form.styl'

import calc from 'calculatorjs'
import dayjs from 'dayjs'
import { mapActions, mapState } from 'vuex'
import API from '@/api'
import Utils from '@/plugins/request/utils'
import formMixin from '@/common/js/form-mixin'
import purchaseMixin from './purchase-mixin'

const addIcon = {
  functional: true,
  props: {
    fill: String
  },
  render(h, context) {
    return (
      <svg viewBox="0 0 46 46" fill={context.props.fill}>
        <path id="形状_2" data-name="形状 2" class="cls-1" d="M682.008,909a23,23,0,1,0,23,23,23,23,0,0,0-23-23h0ZM692.3,932a1.838,1.838,0,0,1-1.84,1.839h-6.61v6.611a1.84,1.84,0,1,1-3.679,0v-6.611h-6.605a1.84,1.84,0,0,1,0-3.679h6.611v-6.606a1.84,1.84,0,0,1,3.679,0v6.612h6.61A1.836,1.836,0,0,1,692.3,932h0Z" transform="translate(-659 -909)"/>
      </svg>
    )
  }
}

const HeaderPart = {
  render() {
    const { title, themeColor, banner } = this.$store.state.activitiesManager.common
    let { useWechatPay, price } = this.$store.state.activitiesManager.signUp
    price = useWechatPay ? calc.div(price, 100) : 0
    return (
      <div class="header-bottom">
        <div class="main-part">
          <img src={banner[0]} alt="banner" />
          <div class="description">
            <div class="title">{title}</div>
            {
              (price !== 0) && useWechatPay && (
                <div class="desc">
                  <span>共计：</span><span class="price" style={`color: ${themeColor}`}>¥{price}</span>
                </div>
              )
            }
          </div>
        </div>
      </div>
    )
  }
}

const YzmComponent = {
  props:['themeColor','send'],
  data(){
    return{
      countDownText:0,
      seconds:60
    }
  },
  methods:{
    sendYzm(){
      this.send('',() => {
        if (!this.timer) {
          this.countDownText = this.seconds
          this.timer = setInterval(() => {
            if (
              this.countDownText > 0 &&
              this.countDownText <= this.seconds
            ) {
              this.countDownText--
            } else {
              clearInterval(this.timer)
              this.timer = null
            }
          }, 1000)
        }
      })
    },
  },
  render(){
    if(this.countDownText){
      return <span class="code" style={'color:' + this.themeColor}>{this.countDownText + 's'}</span>
    }else{
      return <span class="code" style={'color:' + this.themeColor} onClick={this.sendYzm}>获取验证码</span>
    }
  }
}

export default {
  mixins: [formMixin, purchaseMixin],
  components:{
    YzmComponent,
    addIcon
  },
  created() {
    // 获取报名人数限制数据
    this.checkLimitCount()
  },
  data(){
    return {
      files:[
      ],
    }
  },
  computed: {
    ...mapState('activitiesManager', {
      formMap: state => state.formMap
    })
  },
  render() {
    const formList = this.$store.state.activitiesManager.form.items
    const submitButtonText = this.$store.state.activitiesManager.form.submitButtonText
    const { themeColor,openAttachmentUpload,attachmentTitle,attachmentSubTitle } = this.$store.state.activitiesManager.common
    let { price, useWechatPay } = this.$store.state.activitiesManager.signUp
    price = useWechatPay ? calc.div(price, 100) : 0
    console.log(this.$store.state.activitiesManager.common)
    return (
      <div class="activities-manager-form-page">
        <HeaderPart />
        <img onClick={this.handleClickBackBtn} class="back-icon" src="https://image.wxopen.shenhudong.com/v4-wechat-fonted/static/icon/back.svg" alt="back-icon" />
        <div class="form-wrapper">
          <div class="form">
            {
              formList.map(formItem => {
                // 单行文本
                if (formItem.type === 'itemTypeText') {
                  if(+this.$route.params.eventId === 322565){
                    let $textP = '请输入'+formItem.placeholder
                    if(formItem.placeholder == '资源区域') $textP = '全市或具体行政区'
                    if(formItem.placeholder == '个人/团队') $textP = '填写个人或团队，团队写人数'
                    return (
                      <div class="item">
                        <span class="label">{formItem.placeholder}</span>
                        <input
                          value={this.formMap[formItem.key]}
                          data-key={formItem.key}
                          class="input"
                          placeholder={$textP}
                          onInput={this.handleInput}
                          onBlur={this.handleBlurForFixBUG}
                        />
                      </div>
                    )
                  }
                  return (
                    <div class="item">
                      <span class="label">{formItem.placeholder}</span>
                      <input
                        value={this.formMap[formItem.key]}
                        data-key={formItem.key}
                        class="input"
                        placeholder={`请输入${formItem.placeholder}`}
                        onInput={this.handleInput}
                        onBlur={this.handleBlurForFixBUG}
                      />
                    </div>
                  )
                }

                // 多行文本
                if (formItem.type === 'itemTypeMultiLineText') {
                  if(+this.$route.params.eventId === 322565){
                    return (
                      <div class="item" style={`height: 5.2rem`}>
                        <span class="label">{formItem.placeholder}</span>
                        <textarea
                          value={this.formMap[formItem.key]}
                          data-key={formItem.key}
                          class="input"
                          placeholder={'举例:社群数量，资源人数，擅长领域等可做为推广的资源'}
                          onInput={this.handleInput}
                          onBlur={this.handleBlurForFixBUG}
                        />
                      </div>
                    )
                  }
                  return (
                    <div class="item" style={`height: 5.2rem`}>
                      <span class="label">{formItem.placeholder}</span>
                      <textarea
                        value={this.formMap[formItem.key]}
                        data-key={formItem.key}
                        class="input"
                        placeholder={formItem.placeholder}
                        onInput={this.handleInput}
                        onBlur={this.handleBlurForFixBUG}
                      />
                    </div>
                  )
                }
                // 手机
                if (formItem.type === 'itemTypePhone') {
                  return (
                    <div class="item">
                      <span class="label">{formItem.placeholder}</span>
                      <input
                        value={this.formMap[formItem.key]}
                        data-key={formItem.key}
                        class="input"
                        placeholder="请输入手机号"
                        maxlength="11"
                        type="tel"
                        onInput={this.handleInput}
                        onBlur={this.handleBlurForFixBUG}
                      />
                    </div>
                  )
                }

                // 需要短信验证码
                if (formItem.type === 'itemTypeCode') {
                  return (
                    <div class="item">
                      <span class="label">验证码</span>
                      <input
                        minlength="4"
                        maxlength="7"
                        type="tel"
                        class="input"
                        placeholder="请输入验证码"
                        data-key={formItem.key}
                        onInput={this.handleInput}
                        onBlur={this.handleBlurForFixBUG}
                      />
                      <YzmComponent
                        themeColor={themeColor}
                        send={this.handleClickGetCodeBtn}
                      />
                      {/*{*/}
                      {/*  this.countDownText ?<span class="code" style={'color:' + this.themeColor}>{this.countDownText + 's'}</span>:*/}
                      {/*    <span class="code" style={'color:' + this.themeColor} onClick={this.handleClickGetCodeBtn}>获取验证码</span>*/}
                      {/*}*/}
                    </div>
                  )
                }
                // 单选
                if (formItem.type === 'itemTypeSelect') {
                  return (
                    <div class="item">
                      <span class="label">{formItem.placeholder}</span>
                      <select
                        data-key={formItem.key}
                        onInput={this.handleSingleSelect(formItem.key)}
                        value={this.formMap[formItem.key]}
                        class={{
                          select: true,
                          input: true,
                          'hidden-option': !this.formMap[formItem.key]
                        }}
                        onBlur={this.handleBlurForFixBUG}
                      >
                        <option hidden selected disabled value="">{formItem.placeholder}</option>
                        {
                          formItem.range.map(d => (
                            <option data-value={d} value={d}>{d}</option>
                          ))
                        }
                      </select>
                    </div>
                  )
                }

                // 日期
                if (formItem.type === 'itemTypeDate') {
                  const [startDate, endDate] = formItem.range
                  const slots = {
                    default: scope => (
                      <div class="input date-picker" onClick={scope.clickHandler}>
                        {
                          this.formMap[formItem.key] ||
                          <span class="placeholder">请选择{formItem.placeholder}</span>
                        }
                      </div>
                    )
                  }

                  return (
                    <div class="item">
                      <div class="label">{formItem.placeholder}</div>
                      <date-picker
                        data-key={formItem.key}
                        value={this.formMap[formItem.key]}
                        startDate={dayjs.unix(startDate).format('YYYY-MM-DD')}
                        endDate={dayjs.unix(endDate).format('YYYY-MM-DD')}
                        onChange={this.handleSelect(formItem.key)}
                        scopedSlots={slots}
                      />
                    </div>
                  )
                }
                if (formItem.type === 'itemTypeCheckbox') {
                  return (
                    <div class="item">
                      <div class="label">{formItem.placeholder}</div>
                      <form-checkbox
                        formMap={this.formMap}
                        item={formItem}
                        changeForm={this.setFormMap}
                        class="input item"
                      />
                    </div>
                  )
                }
                // 级联选择
                if (formItem.type === 'itemTypeCascader') {
                  const arr = this._setSelectData(formItem.range)
                  return (
                    <multi-picker
                      value={this.formMap[formItem.key] }
                      visible={this.visible}
                      class="input item dj-picker activity"
                      show-name={true}
                      title={formItem.placeholder}
                      limitCount={this.limitCount[formItem.key]}
                      list={arr}
                      data-key={formItem.key}
                      onInput={this.handlePicker(formItem.key)}>
                    </multi-picker>
                  )
                }
              })
            }
          </div>
        </div>
        {
          openAttachmentUpload && (
            <div class="upload-attachment-box">
              <div class="needsclick" onClick={this.uploadFile} style={'width:100%;position:absolute;left:0;top:0;height:2.5rem;z-index:1;'}></div>
              <div class={"form-item"} style={'display:block;'}>
                <div class="label" style={'padding:0.25rem 0 0 0;'}>{attachmentTitle} </div>
                <div class="upload-desc">{attachmentSubTitle}</div>
              </div>
              {/*<img style={'width:1rem;height:1rem;position:absolute;top:0.8rem;right:1.2rem;'} onClick={this.uploadFile} src="https://image.wxopen.shenhudong.com/shd_4/module/230726/%E6%B7%BB%E5%8A%A0.svg" alt=""/>*/}
              <div style={'width:1rem;height:1rem;position:absolute;top:0.8rem;right:1.2rem;'}>
                <addIcon fill={themeColor} />
              </div>
              {
                this.files.map( (item,index) => {
                  return (
                    <div class="form-item">
                      <img class="file-icon" src="https://image.wxopen.shenhudong.com/20230801/169088184519038fa218355cd4daac49527e785af0ba633.jpg?x-oss-process=style/uploadimg" alt=""/>
                      <div style={"width:14rem;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;"}>{item.name}</div>
                      <img class="file-cancel" onClick={() => this.removeFile(index)} src="https://image.wxopen.shenhudong.com/shd_4/module/230726/%E5%85%B3%E9%97%AD.svg" alt=""/>
                    </div>
                  )
                })
              }

              <input type="file" id="fileInput" onChange={this.fileUploadToServer} style={'display:none;'} />
            </div>
          )
        }
        <div style={'width:100%;height:15rem;'}></div>
        <div class="bottom-bar">
          {
            !!price && (
              <div class="left-part">
                <span>需付：</span>
                <span class="price" style={`color: ${themeColor}`}>¥{price}</span>
              </div>
            )
          }
          <div class="right-part" onClick={this.handleClickSubmit} style={`background-color: ${themeColor}`}>
            <span>{submitButtonText}</span>
          </div>
        </div>
      </div>
    )
  },
  mounted() {
    window.history.pushState({
      fromIndex: true
    }, null, '')

    const formSetting = this.$store.state.activitiesManager.form
    const arr = this.addCodeType(formSetting.items)
    if (arr) {
      this.setForm(arr)
    }

    formSetting.items.forEach(ele => {
      this.setFormMap({
        [ele.key]: ''
      })
    })

    // 获取默认报名数据
    let lead = window.localStorage.getItem('activity_lead')
    if(lead) {
      lead = JSON.parse(lead)
      formSetting.items.forEach(item => {
        if(item.key === 'childName'){
          if(lead.bbname){
            this.setFormMap({
              childName: lead.bbname
            })
          }
        }else{
          if(lead[item.key]){
            this.setFormMap({
              [item.key]: lead[item.key]
            })
          }
        }

      })
    }
  },
  methods: {
    uploadFile(){
      document.getElementById('fileInput').click()
    },
    fileUploadToServer(event){
      let file = event.target.files[0]
      if(file.size > 20*1024*1024){
        return this.$vux.toast.show({
          text: '附件大小不能超过20MB',
          type: 'text',
        })
      }
      if(this.files.length >= +this.$store.state.activitiesManager.common.attachmentLimit){
        return this.$vux.toast.show({
          text: `附件上传数量不能超过${this.$store.state.activitiesManager.common.attachmentLimit}个`,
          type: 'text',
        })
      }
      this.uploadFileReq(file)
    },
    removeFile(index){
      this.files.splice(index,1)
    },
    async uploadFileReq(file) {
      try {
        this.$vux.loading.show({text: '上传中'})
        let formData = new FormData()
        formData.append('file',file)
        formData.append('activity_id',this.$route.params.eventId)
        const openid = this.$storage.getItem('openid')
        formData.append('openid',openid)
        $.ajax({
          method: 'POST',
          url: API.common.uploadClientFile,
          data: formData,
          processData: false,
          contentType: false,
          success: (res) => {
            this.$vux.loading.hide()
            if(res.status === 'success'){
              this.files.push({
                'name':file.name,
                'url':res.data.url
              })
              document.getElementById('fileInput').value = ''
            }
          }
        })
      } catch (error) {
        console.error(error)
        this.$vux.loading.hide()
      } finally {
        // this.$vux.loading.hide()
      }
    },
    handleClickSubmit(e) {
      e.stopPropagation()
      const pass = this.formCheck()

      if (!pass) {
        return false
      }

      let extraParams = {}
      if(this.$store.state.activitiesManager.common.openAttachmentUpload){
        if(this.files.length <= 0){
          return this.$vux.toast.show({
            text: '请上传附件',
            type: 'text'
          })
        }
        if(
          +this.$store.state.activitiesManager.common.attachmentLimitMode === 1 &&
          (
            this.files.length > +this.$store.state.activitiesManager.common.attachmentLimit ||
            this.files.length < +this.$store.state.activitiesManager.common.attachmentLimit
          )
        ){
          return this.$vux.toast.show({
            text: '请先上传'+this.$store.state.activitiesManager.common.attachmentLimit+'个附件',
            type: 'text'
          })
        }
        extraParams.attachment = JSON.stringify(this.files)
      }

      this.openWechatPay(e,extraParams)
    },
    handleShowDatePicker() {
      this.$vux.datetime.show({
        value: '',
        confirmText: '确认',
        cancelText: '取消',
        onConfirm(value) {
          console.log(value)
        }
      })
    },
    handleClickBackBtn() {
      this.changePage('IndexPage')
    },
    ...mapActions({
      setFormMap: 'activitiesManager/setFormMap',
      setForm: 'activitiesManager/setForm',
      changePage: 'activitiesManager/changePage'
    })
  }
}